import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ScrollService } from '../../splash-service';

@Component({
  selector: 'app-hero-header',
  templateUrl: './hero-header.component.html',
  styleUrls: ['./hero-header.component.scss']
})
export class HeroHeaderComponent {

  constructor(
    private scrollService: ScrollService,
    private route: Router
  ) {}
  
  navigateTo(route: any[]) {
    this.route.navigate(route);
  }

  scroll(){
    this.scrollService.triggerScroll('Contact');
  }
}
